export const environment = {

    production: true,
    firebase: {
        apiKey: "AIzaSyB2tbGAO2t6SLlrzZATFO2H5CxmwZjWFdA",
        authDomain: "adacad-beta-fa4dc.firebaseapp.com",
        databaseURL: "https://adacad-beta-fa4dc-default-rtdb.firebaseio.com",
        projectId: "adacad-beta-fa4dc",
        storageBucket: "adacad-beta-fa4dc.appspot.com",
        messagingSenderId: "256364414107",
        appId: "1:256364414107:web:335b89a6fd3e1ad31c723e",
        measurementId: "G-JXED6390E5"
    },

    sentry: {
        dsn: "https://3cf82c759b0d55d1d365c341af388bae@o4511911397949440.ingest.us.sentry.io/4511911408959488"
    }
};
